import { Brand } from 'softcat:components/brand.tsx';
import { SidebarNav } from 'softcat:components/sidebar-nav.tsx';

export const Sidebar = () => {
    return (
        <div data-testid="sidebar">
            <div className="px-8 py-4">
                <Brand />
            </div>

            <SidebarNav />
        </div>
    );
};
